// QA-98 (hapday-docs PAYMENTS.md «Upsells after the trial»): a recurring upsell on the saved card is never one tap.
// The first tap shows the price again with how often it renews; only «Confirm and pay» charges.
// Every recurring Stripe upsell price of this funnel renews every 30 days (interval day x 30).
export const UPSELL_RENEWAL_DAYS = 30;

export const needsUpsellConfirm = (type, paymentType) => type === 'subscription' && paymentType !== 'paypal';

export const upsellConfirmText = ({ currencySymbol, firstPrice, fullPrice, everyDays = UPSELL_RENEWAL_DAYS }) =>
  `You will be charged ${currencySymbol}${firstPrice} today, then ${currencySymbol}${fullPrice} every ${everyDays} days until you cancel.`;
